// /acceso → pantalla unificada de acceso y registro, pestaña «Entrar».
import Auth from "@/pages/Auth";

export default function Login() {
  return <Auth tab={0} />;
}
